export const FALLBACK_INSTITUTE_TIMINGS = {
  institute_start_time: "06:00:00",
  institute_end_time: "21:00:00",
  configured: false,
};

export const timeToMinutes = (value) => {
  if (!value) return null;
  const raw = String(value).trim();
  const ampmMatch = raw.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (ampmMatch) {
    let hour = Number(ampmMatch[1]);
    const minute = Number(ampmMatch[2]);
    const ampm = ampmMatch[3].toUpperCase();
    if (ampm === "PM" && hour !== 12) hour += 12;
    if (ampm === "AM" && hour === 12) hour = 0;
    return hour * 60 + minute;
  }
  const hhmmMatch = raw.match(/^(\d{1,2}):(\d{2})$/);
  if (hhmmMatch) return Number(hhmmMatch[1]) * 60 + Number(hhmmMatch[2]);
  const hhmmssMatch = raw.match(/^(\d{1,2}):(\d{2}):(\d{2})$/);
  if (hhmmssMatch) return Number(hhmmssMatch[1]) * 60 + Number(hhmmssMatch[2]);
  return null;
};

export const formatHourHeader = (hourKey) => {
  const hour24 = Number(String(hourKey || "").slice(0, 2));
  if (!Number.isFinite(hour24)) return "-";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  const ampm = hour24 < 12 ? "am" : "pm";
  return `${hour12} ${ampm}`;
};

export const buildHourlySlotsFromTimings = (
  startTime = FALLBACK_INSTITUTE_TIMINGS.institute_start_time,
  endTime = FALLBACK_INSTITUTE_TIMINGS.institute_end_time
) => {
  let startMinutes = timeToMinutes(startTime);
  let endMinutes = timeToMinutes(endTime);

  if (!Number.isFinite(startMinutes) || !Number.isFinite(endMinutes) || endMinutes <= startMinutes) {
    startMinutes = timeToMinutes(FALLBACK_INSTITUTE_TIMINGS.institute_start_time);
    endMinutes = timeToMinutes(FALLBACK_INSTITUTE_TIMINGS.institute_end_time);
  }

  const startHour = Math.floor(startMinutes / 60);
  const endHour = Math.floor(endMinutes / 60);
  const endMinute = endMinutes % 60;

  // When closing time is on the hour (e.g. 21:00), include that hour column (9 pm).
  const lastHour = endMinute === 0 ? endHour : endHour;

  const slots = [];
  for (let hour = startHour; hour <= lastHour; hour += 1) {
    const key = `${String(hour).padStart(2, "0")}00`;
    slots.push({
      key,
      id: key,
      hour,
      label: formatHourHeader(key),
    });
  }

  return slots;
};

export const normalizeTimelineSlots = (timelineSlots) => {
  if (!Array.isArray(timelineSlots) || !timelineSlots.length) return [];

  return timelineSlots
    .map((slot) => {
      const key = String(slot?.key || slot?.id || "").replace(/\D/g, "").padStart(4, "0").slice(0, 4);
      if (!key.endsWith("00")) return null;
      return {
        key,
        id: key,
        hour: Number(key.slice(0, 2)),
        label: slot?.label || formatHourHeader(key),
        start: slot?.start || null,
      };
    })
    .filter(Boolean)
    .sort((a, b) => Number(a.key) - Number(b.key));
};

export const resolveTimelineSlots = ({
  timelineSlots,
  instituteTimings = FALLBACK_INSTITUTE_TIMINGS,
}) => {
  if (instituteTimings?.institute_start_time && instituteTimings?.institute_end_time) {
    const fromTimings = buildHourlySlotsFromTimings(
      instituteTimings.institute_start_time,
      instituteTimings.institute_end_time
    );
    if (fromTimings.length) return fromTimings;
  }

  const fromApi = normalizeTimelineSlots(timelineSlots);
  if (fromApi.length) return fromApi;

  return buildHourlySlotsFromTimings();
};
